import { render, staticRenderFns } from "./ContributionScheduleTabs.vue?vue&type=template&id=07b6eda9"
import script from "./ContributionScheduleTabs.vue?vue&type=script&lang=ts"
export * from "./ContributionScheduleTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports